import React from "react";
import "./Footer.css";

export default function Footer() {
    return (
        <footer className="footer">
            {/* Divider Line */}
            <hr className="footer-hr-line-cc" />

            <div className="footer-container">
                {/* Logo + About */}
                <div className="footer-col footer-brand">
                    <h1 className="cctextlogo">
                        Cosmical <span className="cosmicalorangecolor">Calculator</span>
                    </h1>
                    {/* <p className="footer-text">
                       Your guide through all 16 Jyotish Shastras—Vedic, Tarot, Palmistry & Vastu—with insights from 25,000+ charts read.<br/>
We complete your journey with authentic Pooja Sewa and guidance using certified gems & crystals.
                    </p> */}
                </div>

                {/* Services */}
                <div className="footer-col">
                    <h3 className="footer-title">Services</h3>
                    <ul className="footer-list">
                        <li>Astrological Forecasts</li>
                        <li>Astrological Report</li>
                        <li>Horoscope Readings</li>
                        <li>Love Compatibility</li>
                    </ul>
                </div>

                {/* Links */}
                <div className="footer-col">
                    <h3 className="footer-title">Links</h3>
                    <ul className="footer-list">
                        <li>Home</li>
                        <li>About</li>
                        <li>Services</li>
                        <li>Book Consultation</li>
                        <a href="/privacypolicy"><li><button className="nav-btn" >Privacy Policy</button></li></a>
        <a href="/refundpolicy"><li><button className="nav-btn" >Refund Policy</button></li></a>
        <a href="/terms-and-condition"><li><button className="nav-btn" >Terms and conditions</button></li></a>
                    </ul>
                </div>

                {/* Contact */}
                <div className="footer-col">
                    <h3 className="footer-title">Contact</h3>
                    <ul className="footer-list">
                        <li><span className="footer-icon">📞</span> +91 8708753901</li>
                        {/* <li><span className="footer-icon">✉️</span> cosmicalcalculator@gmail.com</li> */}
                        <li><span className="footer-icon">📍</span>Ambala, Haryana</li>
                    </ul>
                </div>

                {/* Maps */}
                <div className="footer-col">
                    <h3 className="footer-title">Location</h3>
                    <div className="footer-map">
                        <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d55076.07693043081!2d76.7362270642966!3d30.37212158830637!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390fb62a421e6f11%3A0xebd28a29f7258d14!2sAmbala%2C%20Haryana!5e0!3m2!1sen!2sin!4v1759358193313!5m2!1sen!2sin" width="200" height="200" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                    </div>
                </div>
            </div>

            {/* Bottom Bar */}
            <div className="footer-bottom">
                <p>© 2025 Cosmical Calculator — All Rights Reserved</p>
            </div>
        </footer>
    );
}
